export function createObjectFromArray(array) {
	return array.reduce((acc, el) => {
		acc[el[0]] = el[1];
		return acc;
	}, {});
}

export function createObjectFromArrayByKey(array, key) {
	return array.reduce((acc, el) => {
		acc[el[key]] = el;
		return acc;
	}, {});
}
